import axios from 'axios';
import { Dispatch } from 'redux';
import { createAction } from '@reduxjs/toolkit';
import { QContext, QWealthAuthorizationInterceptor } from '@qwealth/qdata';

const AXIOS_INITIALIZED = 'AXIOS_INITIALIZED';

export const initializeAxios = createAction(AXIOS_INITIALIZED);

let unauthenticatedAlert = false;
const UnauthorizedInterceptor = (error) => {
  if (error?.response?.status === 401) {
    if (!unauthenticatedAlert) {
      unauthenticatedAlert = true;
      alert('Please log back in as your QCentral session is expired.');
    }
  }
  return Promise.reject(error);
};

const localV3Api = process.env.REACT_APP_QWEALTH_LOCAL_V3_API;

export const configureAxios = () => async (dispatch: Dispatch): Promise<boolean> => {
  // interceptor to set the authorization only on QW API requests
  axios.interceptors.request.use(QWealthAuthorizationInterceptor);

  // when testing against a local backend, forward the same auth headers
  if (localV3Api) {
    axios.interceptors.request.use(config => {
      if (config.url?.includes(localV3Api)) {
        config.headers.Authorization = `Bearer ${QContext.getIdToken()}`;
        config.headers['user-uuid'] = QContext.getUserUuid();
      }
      return config;
    });
  }

  axios.interceptors.response.use((response) => response, UnauthorizedInterceptor);

  dispatch(initializeAxios());
  return Promise.resolve(true);
};
